<template>
  <div class="release-timing">
    <RadioGroup
      :id="`${id}-mode`"
      label="Ingang"
      :model-value="mode"
      :options="modeOptions"
      @update:modelValue="$emit('update:mode', $event)"
    />
    <DateInput
      v-if="mode === 'scheduled'"
      :id="`${id}-date`"
      label="Ingangsdatum"
      :model-value="date"
      :min="today"
      @update:modelValue="$emit('update:date', $event)"
    />
    <p class="release-timing__hint">{{ hint }}</p>
  </div>
</template>

<script>
  import { computed } from 'vue';
  import RadioGroup from '@/components/inputs/RadioGroup.vue';
  import DateInput from '@/components/inputs/DateInput.vue';

  export default {
    name: 'CatalogReleaseTiming',
    components: { RadioGroup, DateInput },
    props: {
      id: { type: String, default: 'release-timing' },
      mode: { type: String, default: 'now' },
      date: { type: String, default: '' },
    },
    emits: ['update:mode', 'update:date'],
    setup(props) {
      const modeOptions = [
        { value: 'now', label: 'Direct' },
        { value: 'scheduled', label: 'Vanaf een datum' },
      ];
      const today = new Date().toISOString().slice(0, 10);
      const hint = computed(() =>
        props.mode === 'scheduled'
          ? 'Dealers blijven tot die datum op hun huidige versie. Op de datum zelf gaat de nieuwe versie automatisch door, met behoud van hun eigen afwijkingen.'
          : 'Dealers krijgen de nieuwe versie direct, met behoud van hun eigen afwijkingen.'
      );
      return { modeOptions, today, hint };
    },
  };
</script>

<style scoped lang="scss">
  .release-timing {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &__hint {
      margin: 0;
      font-size: 0.8125rem;
      color: var(--slate-500);
    }
  }
</style>
